export default defineComponent({
  inheritAttrs: false,
  props: {}
});